import useGlobalState from '@/composable/states/useGlobalState';

interface TemporaryUserRegister {
  firstName: string,
  lastName: string,
  tel: string,
  email: string,
  shop: {
    id: number
  }
}

const defaultTemporaryUserRegister: TemporaryUserRegister | null = JSON.parse(localStorage.getItem('TemporaryUser') || 'null');

const { mutate, state } = useGlobalState<TemporaryUserRegister | null>({ default: defaultTemporaryUserRegister });

export default function useTemporaryUserRegister() {
  return {
    temporaryUser: state,
    setTemporaryUser: (temporaryUser: TemporaryUserRegister | null) => {
      mutate(temporaryUser);
      if (temporaryUser === null) {
        localStorage.removeItem('temporaryUser');
      } else {
        localStorage.setItem('temporaryUser', JSON.stringify(temporaryUser));
      }
    },
  };
}
